import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declaration, DeclarationGoods, RecursivePartial } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  lrn: string;
  sequence: number;
  partialDeclaration: RecursivePartial<Declaration>;
  partialGoodsShipmentItem?: RecursivePartial<DeclarationGoods>;
  storeSavedDeclaration?: boolean;
}

export const useUpdateDeclarationDataLrn = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ lrn, sequence, partialDeclaration, partialGoodsShipmentItem, storeSavedDeclaration = true }: HookProps) => {
      const result = await apiClient.declarationsCrud.saveDeclarationDataByLrn.mutation({
        params: { lrn },
        body: { sequence, partialDeclaration, partialGoodsShipmentItem },
      });
      if (result.status !== 200) throw result.body;
      return result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
      toast.success('Declaration updated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error updating the declaration!`);
    },
  });
};
